import React from 'react';
import './App.css';
import PokerClock from './components/PokerClock/PokerClock';
import { ThemeProvider } from './contexts/ThemeContext';

function App() {
    return (
        <ThemeProvider>
            <div className="App">
                <PokerClock />
            </div>
        </ThemeProvider>
    );
}

export default App;